export default __webpack_public_path__ + "locales/el-GR/DownloadDialog.json?hash=8daa83f5bdc1616bbb82451b6adce2de";